import React from "react"
import {i18n} from 'core/localization';
import ReactDOM from "react-dom"

import Utils from 'tools/utils'
import FormEntry from "controls/react/form/formEntry"
import {TagsSelect} from "controls/react/tagsSelect"
import {ApplicationState} from "framework/applicationState"
import {createRoot} from "react-dom/client";


export class Tags {
	tagsList = []
	enabled = true

	constructor(config) {
		Utils.apply(this, config);
		this.accountId = this.accountId || ApplicationState.accountId;
		this.container = this.renderEl[0].parentNode

		this.renderTags()
	}

	renderTags() {
		if(this.reactRoot == null) {
			this.reactRoot = createRoot(this.container)
		}
		this.reactRoot.render(
			<FormEntry label={i18n('Tags')} vertical width={'fit'}>
				<TagsSelect
					mode={'tags'}
					disabled={!this.enabled}
					accountId={this.accountContext}
					includeSubaccounts={false}
					onChange={this.onChange}
					value={this.tagsList}
					placeholder={i18n('Tags')}/>
			</FormEntry>)
	}

	onChange = (tagsList) => {
		this.tagsList = tagsList
		this.renderTags()
	}

	enable(bool) {
		this.enabled = bool
		this.renderTags()
	}

	setValues(array) {
		this.tagsList = array.map(x => x.id)
		this.renderTags()
	}

	setRawValues(rawArray) {
		this.tagsList = rawArray
		this.renderTags()
	}

	getValues() {
		return this.tagsList.map(x => ({
			id: x,
			name: x
		}))
	}

	getRawValues() {
		return this.tagsList
	}

	readonly(bool) {
	}

	destroy(){
		this.reactRoot?.unmount()
	}
}
